import http from './axios';

export interface ParamsDto {
  id?: number;
  // 参数编码
  paramCode?: string;
  // 参数名称
  paramName?: string;
  // 参数分类
  paramCategory?: number;
  // 参数类型
  paramKind?: number;
  // 参数默认值
  paramValue?: string;
  // 参数标签
  paramLabel?: string;
  // 参数目录
  paramCategoryId?: number;
  paramCategoryName?: string;
  // 参数排序
  paramSort?: number;
  // 参数描述
  paramDescription?: string;
  // 使用状态，0-启用，1-禁用
  status?: number | boolean;
  approveStatus?: number;
}

export interface CategoryTree {
  label: string;
  icon: string;
  children: any[];
  leafs: {
    id: number;
    code: string;
    name: string;
  }[];
}

export default class ParamsServices {
  private readonly category_api = '/v1/params/category';
  private readonly list_api = '/v1/params/list';
  private readonly info_api = '/v1/params/info';
  private readonly save_api = '/v1/params/save';
  private readonly update_api = '/v1/params/update';
  private readonly remove_api = '/v1/params/delete';
  private readonly ref_list_api = '/v1/paramref/list';
  private readonly ref_update_api = '/v1/paramref/update';

  constructor() {}

  /**
   * 获取参数菜单树
   */
  async getMenuTree() {
    let res: any = await http.get(this.category_api);
    if (!res) return false;
    let payload = res.payload;
    return this.transTreeData(payload);
  }

  async getCategory(params?: object): Promise<any> {
    let res: any = await http.get(this.category_api, { params: params });
    return res.payload;
  }

  async getList(params?: object): Promise<any> {
    let res: any = await http.get(this.list_api, { params: params });
    return res.payload;
  }

  async getEnableList(params?: object): Promise<any> {
    // 0-新建待提交，1-编辑待提交，2-新建已提交，3-编辑已提交，4-新建已审批，5-编辑已审批，6-新建已驳回，7-编辑已驳回
    return await this.getList({ ...params, status_eq: 0, approveStatus_ge: 4, approveStatus_le: 5 });
  }

  async getInfo(id: string | number) {
    let res: any = await http.get(this.info_api + '/' + id);
    return res.payload;
  }

  async add(data: ParamsDto) {
    const params = { ...data, paramSort: '1', paramCode: 'PRM_' + data.paramCode };
    let res: any = await http.post(this.save_api, params);
    return res.header?.code == 200 ? res.payload : false;
  }

  async update(data: ParamsDto): Promise<boolean> {
    let res: any = await http.post(this.update_api, data);
    return res.header?.code == 200;
  }

  async remove(id: string | number) {
    let res: any = await http.post(this.remove_api, [id]);
    return res.header?.code == 200;
  }

  private transTreeData(tree: any) {
    return tree.map((v: CategoryTree) => {
      let item: any = {
        title: v.label,
        icon: v.icon,
        children: []
      };
      if (v.children.length > 0) {
        item.children = this.transTreeData(v.children);
      }
      if (v.leafs.length > 0) {
        v.leafs.forEach((lf: any) => {
          item.children.push({
            title: lf.name,
            key: '/decision/params/detail?id=' + lf.id,
            icon: 'fa-table',
            oprate: [
              { name: '编辑', icon: 'fa-edit', key: '/decision/params/edit?id=' + lf.id },
              { name: '删除', icon: 'fa-trash', key: 'action:remove' }
            ]
          });
        });
      }
      if (item.children.length > 0) {
        item.type = 'folder';
        item.expand = true;
        item.oprate = [
          { name: '新建目录', icon: 'fa-folder', key: 'action:addFolder' },
          { name: '新建', icon: 'fa-plus-circle', key: 'action:add' }
        ];
      }
      return item;
    });
  }

  async getRefList(params?: object): Promise<any> {
    let res: any = await http.get(this.ref_list_api, { params: params });
    return res.payload;
  }

  async updateRef(data: ParamsDto): Promise<boolean> {
    let res: any = await http.post(this.ref_update_api, data);
    return res.header?.code == 200;
  }
}
